import { useModal } from '@ebay/nice-modal-react'
import { type PropsWithChildren, useEffect } from 'react'
import { Portal } from 'react-portal'

import classNames from '../../utils/classNames'
import closeModal from '../../utils/closeModal'
import Backdrop from './backdrop'

type ModalProps = PropsWithChildren<{
  id: string
  containerStyle?: string
  zIndex?: number
  onModalClose?: () => void
  disableOverlayClose?: boolean
  hideOverlay?: boolean
  disableScroll?: boolean
  isFullScreen?: boolean
}>

const Modal = ({
  children,
  containerStyle = '',
  id,
  zIndex,
  onModalClose,
  disableOverlayClose,
  hideOverlay,
  disableScroll = true,
  isFullScreen,
}: ModalProps) => {
  const modal = useModal()

  const isVisible = modal.visible

  useEffect(() => {
    if (disableScroll) {
      isVisible
        ? document.body.classList.add('noscroll')
        : document.body.classList.remove('noscroll')
    }
  }, [isVisible, disableScroll])

  return (
    <Portal>
      {!hideOverlay && (
        <Backdrop
          id={id}
          isVisible={isVisible}
          onClick={() => {
            onModalClose?.()
            !disableOverlayClose && closeModal(modal)
          }}
          zIndex={zIndex ?? 203}
        />
      )}
      <div
        className={classNames(
          'fixed bg-primary pt-[35px] pb-[30px] px-5 left-2/4 top-2/4',
          isFullScreen
            ? 'w-full min-w-full h-full'
            : 'w-[calc(100%_-_60px)] max-w-[400px] rounded-[20px] border-2 border-solid border-tertiary',
          isVisible
            ? 'opacity-100 pointer-events-auto -translate-x-2/4 -translate-y-2/4'
            : 'opacity-0 pointer-events-none -translate-x-2/4 translate-y-[calc(-50%_-_50px]',
          containerStyle,
        )}
        style={{
          zIndex: zIndex ? zIndex + 1 : 204,
        }}>
        {children}
      </div>
    </Portal>
  )
}

export default Modal
